<template>
  <section class="login">
    <div class="login-bg">
      <div class="top-bg">
        <img src="../assets/img/tree-left.png" alt />
        <img src="../assets/img/deng.png" alt />
        <div class="wechat-qrcode">
          <h2>用户注册</h2>
          <div>
            <el-input
              class="register-input"
              prefix-icon="el-icon-mobile-phone"
              placeholder="请输入手机号"
              v-model="phone"
              oninput="value=value.replace(/[^\d]/g,'')"
              clearable
            >
            </el-input>
            <div class="code-div">
              <el-input
                class="register-input flex-input"
                prefix-icon="el-icon-full-screen"
                placeholder="请输入验证码"
                oninput="value=value.replace(/[^\d]/g,'')"
                v-model="code"
                clearable
              >
              </el-input>
              <el-button class="code-btn" @click="onGetCode">{{
                countdown == 60 ? codeBtnTxt : countdown + "秒后可重送"
              }}</el-button>
            </div>
          </div>

          <div class="register-foot">
            <div style="text-align: center;margin-top: 10px">
              <el-checkbox v-model="checked"></el-checkbox>
              <span class="xieyi"
                >我同意<span @click="onUser">《用户协议》</span>和<span
                  @click="onPrivacy"
                  >《隐私政策》</span
                ></span
              >
            </div>
            <el-button
              :disabled="!canRegister"
              type="primary"
              style="margin-top: 10px;"
              @click="onRegister"
              >注册</el-button
            >
          </div>
        </div>
        <img src="../assets/img/tree-right.png" alt />
      </div>
      <div class="bottom-bg"></div>
    </div>
  </section>
</template>

<script>
import { isPhone, getCookie } from "../utils";

export default {
  data() {
    return {
      phone: "",
      code: "",
      checked: false,
      canRegister: false,
      codeBtnTxt: "获取验证码",
      countdown: 60,
      interval: null
    };
  },

  beforeDestroy() {
    console.log(`--- register beforeDestroy`);
    if (!this.interval) {
      clearInterval(this.interval);
    }
  },

  methods: {
    onUser() {
      this.$router.push("/user");
    },

    onPrivacy() {
      this.$router.push("/privacy");
    },

    // 获取验证码
    async onGetCode() {
      if (this.countdown != 60) {
        return;
      }
      if (!this.phone || this.phone.length == 0) {
        this.$message.error(`请填写手机号`);
        return;
      }
      if (!isPhone(this.phone)) {
        this.$message.error(`请填写正确的手机号`);
        return;
      }
      let res = await this.$axios.get(
        `https://zuul.vtoupiao.com/wanyanvote/mdzAppLogin/getMobileCode?phone=${
          this.phone
        }`,
        { headers: { token: "123" } }
      );
      console.log(res);
      this.interval = setInterval(() => {
        if (this.countdown > 1) {
          this.countdown--;
        } else {
          this.countdown = 60;
          this.codeBtnTxt = "重新发送";
        }
      }, 1000);
    },

    // 注册
    async onRegister() {
      if (!this.phone || this.phone.length == 0) {
        this.$message.error(`请填写手机号`);
        return;
      }
      if (!this.code || this.code.length == 0) {
        this.$message.error(`请填写验证码`);
        return;
      }
      if (!this.checked) {
        this.$message.error("请同意《用户协议》与《隐私政策》");
      }
      let unionId = getCookie("unionId");
      let res = await this.$axios.get(
        `https://zuul.vtoupiao.com/wanyanvote/mdzAppLogin/loginByMobile?phone=${
          this.phone
        }&code=${this.code}&type=3&unionId=${unionId}`,
        { headers: { token: "123" } }
      );
      console.log(res);
      if (res.data.code == 1) {
        this.$message.success("注册成功");
        this.$router.replace({ path: "/" });
        return;
      } else {
        this.$message.error("注册失败");
        return;
      }
    }
  },

  watch: {
    phone(newVal) {
      if (
        newVal &&
        newVal.length > 0 &&
        this.code &&
        this.code.length > 0 &&
        this.checked
      ) {
        this.canRegister = true;
      } else {
        this.canRegister = false;
      }
    },

    code(newVal) {
      if (
        newVal &&
        newVal.length > 0 &&
        this.phone &&
        this.phone.length > 0 &&
        this.checked
      ) {
        this.canRegister = true;
      } else {
        this.canRegister = false;
      }
    },

    checked(newVal) {
      if (
        newVal &&
        this.phone &&
        this.phone.length > 0 &&
        this.code &&
        this.code.length > 0
      ) {
        this.canRegister = true;
      } else {
        this.canRegister = false;
      }
    }
  }
};
</script>

<style scoped>
.login-bg {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.top-bg {
  height: 80%;
  background: #535572;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-end;
  overflow: hidden;
}

.bottom-bg {
  height: 100px;
  background: #ffc315;
}

#wc-content {
  width: 100%;
  text-align: center;
}

.wechat-qrcode {
  width: 360px;
  height: 440px;
  background: #fff;
  padding: 30px 40px;
  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.1);
  margin: 10px;
  margin-top: 100px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: stretch;
}

.register-foot {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: stretch;
}

.wechat-qrcode h2 {
  text-align: center;
  /* margin-bottom: 20px; */
}

/* 手机 */
@media screen and (max-width: 768px) {
  .top-bg img {
    display: none;
  }
}

/* Pad */
@media screen and (min-width: 768px) and (max-width: 1023px) {
  .top-bg img {
    display: none;
  }
}

/* 中屏幕电脑 */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
}

/* 大屏幕电脑 */
@media screen and (min-width: 1200px) {
}

.register-input {
  margin: 10px auto;
}

.xieyi {
  margin-left: 10px;
  font-size: 14px;
}

.xieyi span {
  color: #409eff;
}

.code-div {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex-input {
  flex-grow: 1;
}

.code-btn {
  flex-shrink: 0;
  margin-left: 10px;
}
</style>
